import React from 'react'

import { Helmet } from 'react-helmet'

import './landingpage.css'

const LANDINGPAGE = (props) => {
  return (
    <div className="landingpage-container">
      <Helmet>
        <title>exported project</title>
      </Helmet>
      <div className="landingpagelandingpage">
        <img
          alt="Rectangle7638"
          src="/external/rectangle7638-phl-400h.png"
          className="landingpage-rectangle7"
        />
        <img
          alt="image180"
          src="/external/image180-dl4n-700h.png"
          className="landingpage-image"
        />
        <img
          alt="Rectangle1182"
          src="/external/rectangle1182-c8bg-700h.png"
          className="landingpage-rectangle1"
        />
        <span className="landingpage-text10">
          Connect with Construction Professionals, Companies &amp; Clients
        </span>
        <span className="landingpage-text11">
          The digital platform bridging the gap between construction
          professionals, companies, and clients in one seamless environment.
        </span>
        <button className="landingpage-primarybutton1">
          <button className="landingpage-primarybutton8">
            <div className="landingpage-frame31">
              <span className="landingpage-text12">For Companies</span>
            </div>
          </button>
        </button>
        <button className="landingpage-primarybutton2">
          <button className="landingpage-primarybutton9">
            <div className="landingpage-frame32">
              <span className="landingpage-text13">For Professionals</span>
            </div>
          </button>
        </button>
        <button className="landingpage-primarybutton3">
          <button className="landingpage-primarybutton10">
            <div className="landingpage-frame33">
              <span className="landingpage-text14">For Clients</span>
            </div>
          </button>
        </button>
        <button className="landingpage-primarybutton7">
          <button className="landingpage-primarybutton11">
            <div className="landingpage-frame34">
              <span className="landingpage-text15">Learn More</span>
            </div>
          </button>
        </button>
        <button className="landingpage-primarybutton4">
          <button className="landingpage-primarybutton12">
            <div className="landingpage-frame35">
              <span className="landingpage-text16">Sign Up Now</span>
            </div>
          </button>
        </button>
        <button className="landingpage-primarybutton5">
          <button className="landingpage-primarybutton13">
            <div className="landingpage-frame36">
              <span className="landingpage-text17">Sign Up Now</span>
            </div>
          </button>
        </button>
        <button className="landingpage-primarybutton6">
          <button className="landingpage-primarybutton14">
            <div className="landingpage-frame37">
              <span className="landingpage-text18">Get Started Now</span>
            </div>
          </button>
        </button>
        <img
          alt="Rectangle21119"
          src="/external/rectangle21119-fmpa-500h.png"
          className="landingpage-rectangle2"
        />
        <img
          alt="Vector1116"
          src="/external/vector1116-xlj.svg"
          className="landingpage-vector1"
        />
        <span className="landingpage-text19">
          Everything You Need in One Platform
        </span>
        <span className="landingpage-text20">
          Ready to Transform Your Construction Network?
        </span>
        <span className="landingpage-text21">How SyncKreo Works</span>
        <span className="landingpage-text22">
          SyncKreo provides all the tools necessary for successful construction
          networking and project management.
        </span>
        <span className="landingpage-text23">
          Get started in three simple steps and begin connecting with
          construction professionals and clients.
        </span>
        <span className="landingpage-text24">
          Set up your professional profile with your expertise, portfolio, and
          services.
        </span>
        <span className="landingpage-text25">
          Find and connect with other professionals or potential clients in the
          construction industry.
        </span>
        <span className="landingpage-text26">
          Share your work, experience, and successful projects to attract more
          opportunities.
        </span>
        <div className="landingpage-group2">
          <span className="landingpage-text27">Project Showcase</span>
          <span className="landingpage-text28">
            Showcase your best work and expertise through a professional
            portfolio.
          </span>
          <div className="landingpage-lucidebriefcase">
            <div className="landingpage-group5">
              <img
                alt="Vector521"
                src="/external/vector521-798o.svg"
                className="landingpage-vector2"
              />
              <img
                alt="Vector522"
                src="/external/vector522-0ur.svg"
                className="landingpage-vector3"
              />
            </div>
          </div>
        </div>
        <div className="landingpage-group3">
          <span className="landingpage-text29">Client Matching</span>
          <span className="landingpage-text30">
            Find the right professionals or clients for your construction
            projects.
          </span>
          <img
            alt="tablerusers523"
            src="/external/tablerusers523-gg6l.svg"
            className="landingpage-tablerusers"
          />
        </div>
        <div className="landingpage-group4">
          <span className="landingpage-text31">Seamless Communication</span>
          <span className="landingpage-text32">
            Built-in tools for efficient communication and project discussion.
          </span>
          <img
            alt="lucidemessagesquare525"
            src="/external/lucidemessagesquare525-pqod.svg"
            className="landingpage-lucidemessagesquare"
          />
        </div>
        <div className="landingpage-group1">
          <span className="landingpage-text33">Professional Networking</span>
          <span className="landingpage-text34">
            Connect with other construction professionals, companies, and
            potential clients.
          </span>
          <div className="landingpage-lucidenetwork">
            <div className="landingpage-group6">
              <img
                alt="Vector515"
                src="/external/vector515-0fc.svg"
                className="landingpage-vector4"
              />
              <img
                alt="Vector516"
                src="/external/vector516-u71.svg"
                className="landingpage-vector5"
              />
              <img
                alt="Vector517"
                src="/external/vector517-kjx9.svg"
                className="landingpage-vector6"
              />
              <img
                alt="Vector518"
                src="/external/vector518-b1x.svg"
                className="landingpage-vector7"
              />
            </div>
          </div>
        </div>
        <span className="landingpage-text35">01</span>
        <span className="landingpage-text36">02</span>
        <span className="landingpage-text37">03</span>
        <span className="landingpage-text38">Create Your Profile</span>
        <span className="landingpage-text39">Connect &amp; Network</span>
        <span className="landingpage-text40">Showcase Projects</span>
        <span className="landingpage-text41">
          Join SyncKreo today and connect with construction professionals and
          clients in your area.
        </span>
      </div>
    </div>
  )
}

export default LANDINGPAGE
